const FULL_URL_PATTERN =
    '^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$';
const URL_PATH_PATTERN = '^(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$';

const validateString = (str: string, pattern: string) => {
    const regExp = new RegExp(pattern, 'i');

    if (String(str).includes('localhost')) {
        return true;
    }

    return Boolean(regExp.test(str));
};

export const isValidUrl = (str: string) => validateString(str, FULL_URL_PATTERN);
export const isValidURLPath = (str: string) => validateString(str, URL_PATH_PATTERN);
